// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Nr-d","footer":"styles_footer__1xGyd","passCodeTooltip":"styles_passCodeTooltip__EDpzn"};